import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { PayStation } from 'src/features/payment/utils/types';
import { PayStationFormSchemaValues } from 'src/features/payment/utils/formSchema';

const RESOURCE = `sp-core/:parkingId/paystations/pay-station/:payStationId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
    data: PayStationFormSchemaValues;
    payStationId: string;
}
const mutationFn = ({ payStationId, data, parkingId }: DTO): Promise<PayStation> => {
    return axios.patch(formatResourcePath(RESOURCE, { payStationId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdatePayStation };
